import React, { useState, useEffect, useContext } from "react";
import "scss/components/maintenance/maintenanceHandle.scss";
import { Divider, Header, Icon, Segment, Table } from "semantic-ui-react";
import province from "assets/data/province.json";
import { DeviceContext } from "context/deviceProvider";
import { END_POINT } from "context/endPoint";

export default function MaintenanceHandle(props) {
  const [detail, setDetail] = useState(props?.order);
  const [part, setPart] = useState([]);
  const devices = useContext(DeviceContext);

  useEffect(() => {
    setDetail(props?.order);
    console.log(props?.order);
  });

  const onGetMonth = (month) => {
    const monthNames = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม",
    ];
    return monthNames[parseInt(month) - 1];
  };

  const mapPart = (data, name) => {
    let part = devices?.partsList?.filter((parts) => parts.code === data);

    if (part?.length > 0) {
      if (name === "code") {
        return part[0].name_th;
      } else if (name === "price") {
        return parseInt(part[0].price);
      }
    }
  };
  const getIssueParts = () => {
    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
            <Table.HeaderCell>จำนวน</Table.HeaderCell>
            <Table.HeaderCell>ราคา/ชิ้น</Table.HeaderCell>
            <Table.HeaderCell>ราคารวม</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {detail?.handlePartUseList?.map((order, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{mapPart(order?.partCode, "code")}</Table.Cell>
              <Table.Cell>{order?.qty}</Table.Cell>
              <Table.Cell>
                {mapPart(order?.partCode, "price")?.toLocaleString()}฿
              </Table.Cell>
              <Table.Cell>
                {(
                  mapPart(order?.partCode, "price") * order?.qty
                ).toLocaleString()}
                ฿
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  const getOptionalParts = () => {
    return (
      <Table celled className="optional">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
            <Table.HeaderCell>จำนวน</Table.HeaderCell>
            <Table.HeaderCell>ราคา/ชิ้น</Table.HeaderCell>
            <Table.HeaderCell>ราคารวม</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {detail?.optionalPartList?.map((order, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{order?.partName}</Table.Cell>
              <Table.Cell>{order?.qty}</Table.Cell>
              <Table.Cell>{order?.price}฿</Table.Cell>
              <Table.Cell>
                {(order?.price * order?.qty).toLocaleString()}฿
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  const handleGetCost = () => {
    let priceTotal = 0;
    let partPrice = 0;
    let optionalPartPrice = 0;

    detail?.handlePartUseList?.length > 0 &&
      detail?.handlePartUseList.map((part) =>
        devices.partsList?.map((temp) =>
          temp.code === part.partCode ? (partPrice += temp.price * part.qty) : 0
        )
      );

    detail?.optionalPartList?.map(
      (part) => (optionalPartPrice += part.qty * part.price)
    );

    priceTotal = partPrice + optionalPartPrice;

    return priceTotal;
  };

  const onMapProvince = (data) => {
    let check = province.filter((text) => text.value === data);
    if (check.length > 0) {
      return check[0].text;
    }
    return "-";
  };

  const displayImages = () => {
    return (
      <>
        <div className="image">
          <Divider horizontal>
            <Header as="h4">
              <Icon name="images" />
              รูปภาพ
            </Header>
          </Divider>
          <div className="image-add">
            {detail?.images?.handle?.length > 0 &&
              detail?.images?.handle?.map((image, idx) => (
                <div key={idx} className="fadein">
                  <img
                    key={idx}
                    alt="add-maintenance"
                    src={`${END_POINT}/get/image?name=${image.path}`}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="maintenanceHandle">
      <div className="maintenanceHandle-topic">
        <Divider horizontal>
          <Header as="h3">
            <Icon name="edit outline" />
            การแก้ไข
          </Header>
        </Divider>
      </div>
      <Segment>
        <table className="handle">
          <tbody>
            <tr>
              <td>วิธีการแก้ไข</td>
              <td>{detail?.handleNote || "-"}</td>
            </tr>
            <tr>
              <td>วันที่ทำการแก้ไข</td>
              <td>
                {detail?.handleDate?.substring(8, 10)}{" "}
                {onGetMonth(detail?.handleDate?.substring(5, 7))}{" "}
                {parseInt(detail?.handleDate?.substring(0, 4)) + 543}
              </td>
            </tr>
            <tr>
              <td>ชื่อผู้รับผิดชอบ</td>
              <td>
                {detail?.ownerEngineerList?.map((name, idx) => (
                  <span key={idx}>
                    {name.name}{" "}
                    {idx + 1 !== detail?.ownerEngineerList?.length && "/ "}
                  </span>
                ))}
              </td>
            </tr>
            <tr>
              <td>จังหวัดที่แก้ไข</td>
              <td>{onMapProvince(detail?.provinceId)}</td>
            </tr>
            <tr>
              <td>ราคารวมอะไหล่</td>
              <td>{handleGetCost()?.toLocaleString()} บาท</td>
            </tr>
            <tr>
              <td>หมายเหตุ</td>
              <td>{detail?.handleRemark || "-"}</td>
            </tr>
            <tr>
              <td>อะไหล่ที่ใช้</td>
              <td>
                {detail?.handlePartUseList?.length > 0 ? getIssueParts() : "-"}
              </td>
            </tr>
            <tr>
              <td>อะไหล่ที่ใช้เพิ่มเติม</td>
              <td>
                {detail?.optionalPartList?.length > 0
                  ? getOptionalParts()
                  : "-"}
              </td>
            </tr>
          </tbody>
        </table>

        {displayImages()}
      </Segment>
    </div>
  );
}
